import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const HapiIframe = ({
  token,
  processId,
  clientId = 92,
  clientUserGuid = 'de565db4-a8bd-4e04-aa8e-8154d2e8b3d7',
  scriptId = 'hapi-iframe-script',
}) => {
  const containerRef = useRef(null);
  const movedOnceRef = useRef(false);
  const location = useLocation();

  // 1) Definir HAPI_SRC com base na rota
  const getHapiSrcFromPath = () => {
    const path = location.pathname;
    if (path.includes('ss')) return 'https://storage.googleapis.com/hapipublicresources/scripts/hapiiframe_ssonly.js';
    if (path.includes('docs')) return 'https://storage.googleapis.com/hapipublicresources/scripts/hapiiframe_docsonly.js';
    return 'https://storage.googleapis.com/hapipublicresources/scripts/hapiiframe_current.js';
  };

  const HAPI_SRC = getHapiSrcFromPath();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    try {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      if (processId) params.set('Guid', String(processId));
      if (token) params.set('token', String(token));

      const next = `${url.pathname}?${params.toString()}${url.hash || ''}`;
      window.history.replaceState({}, '', next);
    } catch {
      /* ignore */
    }

    const prev = document.getElementById(scriptId);
    if (prev && prev.parentElement) prev.parentElement.removeChild(prev);

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = HAPI_SRC;
    script.async = true;

    script.setAttribute('data-clientid', String(clientId));
    script.setAttribute('data-clientuserguid', String(clientUserGuid));
    if (processId) script.setAttribute('data-guid', String(processId));
    if (token) script.setAttribute('data-token', String(token));
    script.setAttribute('data-sourceurl', window.location.href);

    document.body.appendChild(script);

    const observer = new MutationObserver(() => {
      if (!containerRef.current || movedOnceRef.current) return;

      const injected = document.querySelector(
        'iframe[src*="hapi.outsystemscloud.com"], iframe[src*="hapi.pt"], iframe[src*="HAPI/Common"]'
      );

      if (injected) {
        containerRef.current.appendChild(injected);

        injected.style.width = '100%';
        injected.style.border = 'none';

        movedOnceRef.current = true;
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      const el = document.getElementById(scriptId);
      if (el && el.parentElement) el.parentElement.removeChild(el);
      movedOnceRef.current = false;
    };
  }, [HAPI_SRC, token, processId, clientId, clientUserGuid, scriptId]);

  return (
    <div
      ref={containerRef}
      className="w-full bg-gray-100 rounded-md overflow-hidden"
    />
  );
};

export default HapiIframe;